var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.863,
    height: 16.638,
    viewBox: "0 0 16.863 16.638",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.742.732A7.242,7.242,0,0,1,9.623,2.825,7.242,7.242,0,0,1,4.5.732,7.049,7.049,0,0,1,2.383-4.319,7.036,7.036,0,0,1,4.166-9.014L.145-12.981a.483.483,0,0,1,0-.69.5.5,0,0,1,.35-.143.5.5,0,0,1,.35.143L4.865-9.7a7.243,7.243,0,0,1,4.758-1.759A7.242,7.242,0,0,1,14.742-9.37a7.049,7.049,0,0,1,2.121,5.051A7.049,7.049,0,0,1,14.742.732Zm-.7-9.413a6.318,6.318,0,0,0-8.84,0A6.117,6.117,0,0,0,5.2.042a6.274,6.274,0,0,0,4.42,1.8,6.275,6.275,0,0,0,4.42-1.8A6.117,6.117,0,0,0,14.043-8.68Z",
    transform: "translate(16.863 2.825) rotate(180)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.38b58a42315b3a1213cbcd895526d5c2.svg";
export { ForwardRef as ReactComponent };